// Fragment "marketing opt-in" — the optional, UNTICKED "send me news and offers from
// {practice}" box on every booking and client checkout (components/consent/
// MarketingOptIn.jsx), and the client's own email preferences on the account page
// (public/PortalEmailPreferences.jsx). Canada's CASL asks for exactly this: a box nobody
// ticked for the client, naming who will write and what they will send. Merged in
// ./index.js.
export default {
  fr: {
    "marketingOptIn.label": "Envoyez-moi par e-mail les nouvelles et les offres de {practice}",
    "marketingOptIn.hint": "Facultatif. Vous pourrez vous désabonner à tout moment.",
    "marketingOptIn.practiceFallback": "ce cabinet",
    "portalEmail.title": "Préférences d'e-mail",
    "portalEmail.intro": "Nouvelles et offres de {practice} : promotions, nouveaux services et actualités. Les e-mails liés à vos rendez-vous et à vos achats sont toujours envoyés.",
    "portalEmail.status.consented": "Vous recevez les nouvelles et les offres de {practice}.",
    "portalEmail.status.not_consented": "Vous ne recevez pas les nouvelles et les offres de {practice}.",
    "portalEmail.status.unsubscribed": "Vous vous êtes désabonné·e des nouvelles et des offres de {practice}.",
    "portalEmail.optIn": "Recevoir les nouvelles et les offres",
    "portalEmail.optOut": "Ne plus recevoir les nouvelles et les offres",
    "portalEmail.saveError": "Votre choix n'a pas pu être enregistré. Merci de réessayer.",
  },
  en: {
    "marketingOptIn.label": "Send me news and offers from {practice} by email",
    "marketingOptIn.hint": "Optional. You can unsubscribe at any time.",
    "marketingOptIn.practiceFallback": "this practice",
    "portalEmail.title": "Email preferences",
    "portalEmail.intro": "News and offers from {practice}: promotions, new services and updates. Emails about your appointments and purchases are always sent.",
    "portalEmail.status.consented": "You receive news and offers from {practice}.",
    "portalEmail.status.not_consented": "You don't receive news and offers from {practice}.",
    "portalEmail.status.unsubscribed": "You unsubscribed from news and offers from {practice}.",
    "portalEmail.optIn": "Send me news and offers",
    "portalEmail.optOut": "Stop news and offers",
    "portalEmail.saveError": "Your choice could not be saved. Please try again.",
  },
  es: {
    "marketingOptIn.label": "Envíenme por correo electrónico las novedades y ofertas de {practice}",
    "marketingOptIn.hint": "Opcional. Puede darse de baja en cualquier momento.",
    "marketingOptIn.practiceFallback": "esta consulta",
    "portalEmail.title": "Preferencias de correo",
    "portalEmail.intro": "Novedades y ofertas de {practice}: promociones, nuevos servicios y noticias. Los correos sobre sus citas y compras se envían siempre.",
    "portalEmail.status.consented": "Recibe las novedades y ofertas de {practice}.",
    "portalEmail.status.not_consented": "No recibe las novedades y ofertas de {practice}.",
    "portalEmail.status.unsubscribed": "Se dio de baja de las novedades y ofertas de {practice}.",
    "portalEmail.optIn": "Recibir novedades y ofertas",
    "portalEmail.optOut": "Dejar de recibir novedades y ofertas",
    "portalEmail.saveError": "No se pudo guardar su elección. Inténtelo de nuevo.",
  },
};
